import { render, staticRenderFns } from "./InWayInvetoryOrders.vue?vue&type=template&id=21aae3d0&"
import script from "./InWayInvetoryOrders.vue?vue&type=script&lang=js&"
export * from "./InWayInvetoryOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports